/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ExternalRedirect = ({ url }) => {
  const navigate = useNavigate();
  useEffect(() => {
    window.open(url, '_blank');
    navigate(-1);
  }, [url, navigate]);
  return null;
};

export default ExternalRedirect;
